import Client from 'Api/Client';
import EndPoint from 'Api/EndPoint';

const endpoint = `${EndPoint.Host}/${EndPoint.OrderSupport}`;

// 제안서/투시도 > 요청 파일 업로드
export const FILE_PROPOSAL = `${EndPoint.HostPath}/orderSupport/proposal/file`;

// 체크리스트 > 체크리스트 이미지 업로드
export const FILE_CONSULT = `${EndPoint.HostPath}/orderSupport/consult/file`;

// 체크리스트 > 추가정보 파일 업로드(도면, 추가파일)
export const FILE_CHECKLIST = `${EndPoint.HostPath}/orderSupport/checkList/file`;

// 대화방 > 파일 업로드
export const FILE_FRONT = `${EndPoint.HostPath}/orderSupport/comment/file/front`;

export async function getConfigs(data) {
  return await Client.get(`${endpoint}/config/keys`, data, true);
}

export async function getCheckLists() {
  return await Client.get(`${endpoint}/config/all`, {}, true);
}

export async function createConsult(data) {
  return await Client.post(`${endpoint}/consult`, data, true);
}

export async function getList(data) {
  return await Client.get(`${endpoint}/consult`, data, true);
}

export async function getStaffsList() {
  return await Client.get(`${endpoint}/consult/staffs`, {}, true);
}

export async function getDetail(id) {
  return await Client.get(`${endpoint}/consult/${id}`, {}, true);
}

export async function editConsult(id, data) {
  return await Client.put(`${endpoint}/consult/${id}`, data, true);
}

export async function editConsultStatus(id, data) {
  return await Client.put(`${endpoint}/consult/${id}/status`, data, true);
}

export async function sendCustomerVerificationEmail(id, data) {
  return await Client.put(`${endpoint}/consult/${id}/sendCustomerVerificationEmail`, data, true);
}

export async function getAutoComplete(data) {
  return await Client.get(`${endpoint}/consult/autoComplete`, data, true);
}

export async function writeCheckList(id, data) {
  return await Client.put(`${endpoint}/checkList/${id}`, data, true);
}
export async function putCheckListCommercialCommon(id, data) {
  return await Client.put(`${endpoint}/checkList/${id}/commercial/common`, data, true);
}
export async function postCheckListCommercialSpace(id, data) {
  return await Client.post(`${endpoint}/checkList/${id}/commercial/space`, data, true);
}
export async function putCheckListCommercialSpace(id, data, spaceId) {
  return await Client.put(`${endpoint}/checkList/${id}/commercial/space/${spaceId}`, data, true);
}
export async function deleteCheckListCommercialSpace(id, spaceId) {
  return await Client.delete(`${endpoint}/checkList/${id}/commercial/space/${spaceId}`, {}, true);
}

export async function writeDetailInfo(id, data) {
  return await Client.put(`${endpoint}/checkList/${id}/detailInfo`, data, true);
}

export async function getProductInfo(data) {
  return await Client.post(`${endpoint}/proposal/productInfo`, data, true);
}

export async function requestProposal(id, data) {
  return await Client.post(`${endpoint}/proposal/${id}/request`, data, true);
}

export async function createVirtualAccount(parentId, id, data) {
  return await Client.post(`${endpoint}/payment/${parentId}/${id}/toss/virtualAccount`, data, true);
}

export async function createTossPayLink(parentId, id) {
  return await Client.post(`${endpoint}/payment/${parentId}/${id}/toss/payLink`, {}, true);
}

export async function getComment(id, data) {
  return await Client.get(`${endpoint}/comment/${id}`, data, true);
}

export async function postComment(id, data) {
  return await Client.post(`${endpoint}/comment/${id}`, data, true);
}

// 체크리스트 이미지업로드
export async function uploadFileConsult(image, onProgress = null) {
  return await Client.uploadFileWithoutCompress(`${endpoint}/consult/file`, 'image', image, onProgress);
}

// 제안서/투시도 > 요청 파일 업로드
export async function uploadProposalFile(image, onProgress = null) {
  return await Client.uploadFile(`${endpoint}/proposal/file`, 'image', image, onProgress);
}
// 제안서/투시도 > 요청 파일 업로드 Without Compress
export async function uploadWithoutCompressProposalFile(image, onProgress = null) {
  return await Client.uploadFileWithoutCompress(`${endpoint}/proposal/file`, 'image', image, onProgress);
}
